/* Retired Searchanise links keep their exact selection, not a broader stand-in. */
(() => {
  if(window.FHLegacyFilters)return;
  // Two dialects, kept apart. `rb_product_type` carries raw Shopify product types: the
  // census in docs/native-discovery/product-type-census-2026-09-20.json shows Vinyl
  // Die-Cut Character, Icon and Logo are three distinct types inside one Product Line, so
  // a Product Line destination would silently broaden the selection. The ptag parameter
  // carries Product Line labels and keeps line semantics.
  const TYPE_PARAM='rb_product_type';
  const LINE_PARAM='rb_filter_ptag_88438501d7078e53fd478b09692a3926';
  const PARAMS=[TYPE_PARAM,LINE_PARAM];
  // Exact values the indexed contract accepts for fh.legacy_type.
  const LEGACY_TYPES=['Vinyl Die Cut Character','Vinyl Die Cut Icon','Vinyl Die Cut Logo','Poster','Mural','Big Head','Big Heads','Stand Out','Stand Out Mini','Wallpaper','Minis','Mini Decals','Dry Erase','Growth Chart','Growth Charts'];
  // Exact whole tags and fixed tag namespaces the contract accepts.
  const TAGS=['fh-line-peel-and-stick-posters','fh-line-peel-and-stick-wallpaper','fh-family-stand-outs','fh-family-mini-decals'];
  const TAG_PREFIXES={'fh-athlete':'fh-athlete-','fh-logo':'fh-logo-'};
  // The only documented spelling difference is an optional hyphen between Die and Cut.
  const typeKey=value=>String(value).trim().toLowerCase().replace(/\s+/g,' ').replace(/\bdie-cut\b/g,'die cut');
  const LEGACY_TYPE_BY_KEY=new Map(LEGACY_TYPES.map(value=>[typeKey(value),value]));
  // Menu selections separate with a pipe; the contract also asks the theme to split the
  // Poster/Mural pair into two exact values. No allowed value contains either character.
  const TYPE_SEPARATORS=/[|/]/;
  const LINE_SEPARATORS=/\|/;
  // Storefront sort values the catalog engine can serve, plus the one vendor sort the
  // live links carry. Searchanise `sales_amount` is its best-sellers ordering.
  const SORTS=['best-selling','price-ascending','price-descending','created-descending','relevance','manual'];
  const VENDOR_SORTS={sales_amount:'best-selling'};
  // Values FHCatalogEngine.requestPlan still accepts, so a mapped destination stays servable.
  const CARRY=new Set(['q','type','options[unavailable_products]','sort_by','preview_theme_id','_fd','pb','gclid','fbclid']);
  // `page` resets because a new selection starts on page one, as the catalog's own filter
  // links do; `tab` is the vendor's result-kind switch, already expressed by type=product.
  const DROP=new Set(['page','tab']);
  // Scope tokens the theme already treats as real browse collections
  // (snippets/fh-catalog-body.liquid). No handle is invented here.
  const SCOPES={nfl:'nfl',nba:'nba',mlb:'mlb',nhl:'nhl',wwe:'wwe',bluey:'bluey'};
  const MAX_VALUES=8,MAX_TYPE=100,MAX_VALUE=256,MAX_URL=8192,MAX_TOKENS=8;
  const CONTROL=new RegExp('[\\u0000-\\u001f\\u007f\\ufffd]');
  const unreadable=value=>value.length>MAX_VALUE||CONTROL.test(value);
  const recognized=url=>PARAMS.some(param=>url.searchParams.has(param));
  const none=()=>({status:'none',reason:'',selection:null,url:null});
  const fail=reason=>({status:'unsupported',reason,selection:null,url:null});
  const empty=()=>({legacyTypes:[],lines:[],tags:[],tagPrefixes:[]});
  const add=(list,value)=>{if(!list.includes(value))list.push(value);return list.length<=MAX_VALUES;};

  function selections(url){
    const found=empty();
    for(const raw of url.searchParams.getAll(TYPE_PARAM)){
      if(unreadable(raw))return {reason:'unreadable_value'};
      const parts=raw.split(TYPE_SEPARATORS).map(part=>part.trim()).filter(Boolean);
      if(!parts.length)return {reason:'unknown_value'};
      for(const part of parts){
        if(part.length>MAX_TYPE)return {reason:'unreadable_value'};
        const value=LEGACY_TYPE_BY_KEY.get(typeKey(part));
        if(!value)return {reason:'unknown_value'};
        if(!add(found.legacyTypes,value))return {reason:'too_many_values'};
      }
    }
    const resolve=window.FHProductCards?.resolveLine;
    for(const raw of url.searchParams.getAll(LINE_PARAM)){
      if(typeof resolve!=='function')return {reason:'contract_unavailable'};
      if(unreadable(raw))return {reason:'unreadable_value'};
      const parts=resolve(raw)?[raw]:raw.split(LINE_SEPARATORS).map(part=>part.trim()).filter(Boolean);
      if(!parts.length)return {reason:'unknown_value'};
      for(const part of parts){
        const line=resolve(part);
        if(!line)return {reason:'unknown_value'};
        if(line.ambiguous)return {reason:'ambiguous_value'};
        if(!add(found.lines,line.id))return {reason:'too_many_values'};
      }
    }
    return found.legacyTypes.length||found.lines.length?{selection:found}:{reason:'unknown_value'};
  }

  // Keeps only values the catalog request plan accepts; everything else is a refusal.
  function carryParams(url,query){
    const carry=[];
    for(const [key,value] of url.searchParams){
      if(PARAMS.includes(key))continue;
      if(DROP.has(key)){if(key==='tab'&&value!=='products')return {reason:'unsupported_parameter'};continue;}
      if(!CARRY.has(key)&&!/^utm_[a-z0-9_]{1,32}$/.test(key))return {reason:'unsupported_parameter'};
      if(url.searchParams.getAll(key).length!==1||unreadable(value))return {reason:'unsupported_parameter'};
      if(key==='preview_theme_id'&&!/^\d{1,20}$/.test(value))return {reason:'unsupported_parameter'};
      if(key==='type'&&value!=='product')return {reason:'unsupported_parameter'};
      if(key==='options[unavailable_products]'&&value!=='hide')return {reason:'unsupported_parameter'};
      if(key==='sort_by'){
        const sort=SORTS.includes(value)?value:VENDOR_SORTS[value];
        if(!sort)return {reason:'unsupported_sort'};
        carry.push(['sort_by',sort]);continue;
      }
      if(key==='q'){if(query)carry.push(['q',query]);continue;}
      carry.push([key,value]);
    }
    return {carry};
  }

  const localeOf=path=>path.match(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/)?.[0]||'';
  const safePath=path=>/^\/(?!\/)[a-z0-9\-/]*$/i.test(path);

  function build(url,path,carry,selection,{search=false}={}){
    const target=new URL(path,url.origin);
    if(target.origin!==url.origin)return fail('unsupported_url');
    for(const [key,value] of carry){
      if(!search&&(key==='q'||key==='type'||key==='options[unavailable_products]'))continue;
      target.searchParams.append(key,value);
    }
    if(search){target.searchParams.set('type','product');target.searchParams.set('options[unavailable_products]','hide');}
    // Repeated values are OR inside a dimension; separate dimensions are AND.
    for(const value of selection.legacyTypes)target.searchParams.append('fh.legacy_type',value);
    for(const value of selection.lines)target.searchParams.append('fh.product_line',value);
    for(const value of selection.tags)target.searchParams.append('fh.tag',value);
    for(const value of selection.tagPrefixes)target.searchParams.append('fh.tag_prefix',value);
    if(target.href.length>MAX_URL)return fail('unsupported_url');
    return {status:'mapped',reason:'',selection,url:target};
  }

  // Returns a same-origin destination or an explicit reason. Callers read pathname and
  // search only; nothing here is ever written into HTML.
  function translate(url,{surface='collection',basePath=''}={}){
    if(!recognized(url))return fail('no_legacy_parameters');
    if(url.hash||url.href.length>MAX_URL)return fail('unsupported_url');
    const found=selections(url);
    if(!found.selection)return fail(found.reason);
    const query=(url.searchParams.get('q')||'').trim();
    const collected=carryParams(url,query);
    if(collected.reason)return fail(collected.reason);
    const search=surface!=='collection';
    const path=search&&basePath?basePath:url.pathname;
    if(!safePath(path))return fail('unsupported_url');
    return build(url,path,collected.carry,found.selection,{search});
  }

  // The live menu also links the retired page with a tag-like query, e.g.
  // `?tab=products&type=product&sort_by=sales_amount&page=1&q=fh-family-mini-decals NFL`.
  // Those carry an exact tag, tag namespace or product type plus a scope, never shopper text.
  function scopeOf(query){
    const tokens=query.split(/\s+/).filter(Boolean);
    if(tokens.length<2||tokens.length>MAX_TOKENS)return null;
    let handle='';const rest=[];
    for(const token of tokens){
      const key=token.toLowerCase();
      if(!handle&&Object.hasOwn(SCOPES,key))handle=SCOPES[key];else rest.push(token);
    }
    if(!handle||!rest.length)return null;
    const remainder=rest.join(' '),key=remainder.toLowerCase();
    const selection=empty();
    if(Object.hasOwn(TAG_PREFIXES,key))selection.tagPrefixes.push(TAG_PREFIXES[key]);
    else if(TAGS.includes(key))selection.tags.push(key);
    else{
      const type=LEGACY_TYPE_BY_KEY.get(typeKey(remainder));
      if(!type)return null;
      selection.legacyTypes.push(type);
    }
    return {handle,selection};
  }
  function translateQuery(url,{basePath=''}={}){
    if(recognized(url)||url.hash||url.href.length>MAX_URL)return none();
    const values=url.searchParams.getAll('q');
    if(values.length!==1)return none();
    const query=values[0].trim();
    if(!query||unreadable(query))return none();
    // Only the vendor's own menu links are reinterpreted: they carry its result-kind
    // switch or a namespaced tag token. Shopper text keeps the existing recovery path.
    const tagged=/(?:^|\s)fh-[a-z0-9-]+(?=\s|$)/i.test(query);
    if(!url.searchParams.has('tab')&&!tagged)return none();
    const scope=scopeOf(query);
    // A tag token is machine state, not something to hand back to the shopper as text.
    if(!scope)return fail(tagged?'vendor_tag_query':'unmapped_tag_query');
    const collected=carryParams(url,query);
    if(collected.reason)return fail(collected.reason);
    const path=localeOf(basePath||url.pathname)+'/collections/'+scope.handle;
    if(!safePath(path))return fail('unsupported_url');
    return build(url,path,collected.carry,scope.selection);
  }

  function recover(url,options={}){return recognized(url)?translate(url,options):translateQuery(url,options);}
  window.FHLegacyFilters={recognized,translate,translateQuery,recover,params:()=>[...PARAMS],legacyTypes:()=>[...LEGACY_TYPES],tags:()=>[...TAGS],tagPrefixes:()=>Object.values(TAG_PREFIXES)};
})();
